function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2729_88444)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.0245 8.0115C7.72825 9.24786 8.75214 10.2717 9.9885 10.9755L10.6515 10.047C10.7581 9.8977 10.9158 9.79266 11.0946 9.75175C11.2734 9.71084 11.4611 9.7369 11.622 9.825C12.6827 10.4047 13.8542 10.7533 15.0592 10.848C15.2473 10.8629 15.4229 10.9482 15.5509 11.0867C15.6789 11.2253 15.75 11.4071 15.75 11.5958V14.9423C15.75 15.1279 15.6812 15.3071 15.5568 15.4449C15.4324 15.5828 15.2612 15.6696 15.0765 15.6885C14.679 15.7297 14.2785 15.75 13.875 15.75C7.455 15.75 2.25 10.545 2.25 4.125C2.25 3.7215 2.27025 3.321 2.3115 2.9235C2.33044 2.73877 2.41724 2.56764 2.55509 2.44323C2.69295 2.31881 2.87205 2.24996 3.05775 2.25H6.40425C6.59292 2.24998 6.77467 2.32106 6.91326 2.44909C7.05185 2.57711 7.13709 2.75267 7.152 2.94075C7.24667 4.14584 7.59531 5.31726 8.175 6.378C8.2631 6.53892 8.28916 6.72656 8.24825 6.9054C8.20734 7.08424 8.1023 7.24188 7.953 7.3485L7.0245 8.0115ZM5.133 7.51875L6.558 6.501C6.15359 5.62807 5.87651 4.70163 5.73525 3.75H3.7575C3.753 3.8745 3.75075 3.99975 3.75075 4.125C3.75 9.717 8.283 14.25 13.875 14.25C14.0002 14.25 14.1255 14.2478 14.25 14.2425V12.2648C13.2984 12.1235 12.3719 11.8464 11.499 11.442L10.4813 12.867C10.0715 12.7078 9.6735 12.5198 9.29025 12.3045L9.24675 12.2797C7.77568 11.4425 6.55746 10.2243 5.72025 8.75325L5.6955 8.70975C5.48018 8.3265 5.29221 7.9285 5.133 7.51875Z",
  fill: "#07003D",
  fillOpacity: 0.3
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2729_88444"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})));

var SvgPhoneIcon = function SvgPhoneIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPhoneIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/phoneIcon.d5caf644.svg";
export { ForwardRef as ReactComponent };